import { render } from "./user.need.batch.vue?vue&type=template&id=385f26a4"
import script from "./user.need.batch.vue?vue&type=script&lang=js"
export * from "./user.need.batch.vue?vue&type=script&lang=js"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__